import React from 'react';
import Hero from './Hero';
import Games from './Games';
import About from './About';
import Team from './Team';
import Career from './Career';
import Technology from './Technology';
import Contact from './Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <Games />
      <About />
      <Team />
      <Career />
      <Technology />
      <Contact />
    </>
  );
};

export default Home;

